import { render, staticRenderFns } from "./dialogos-top.vue?vue&type=template&id=d9424894&scoped=true&"
import script from "./dialogos-top.vue?vue&type=script&lang=js&"
export * from "./dialogos-top.vue?vue&type=script&lang=js&"
import style0 from "./dialogos-top.vue?vue&type=style&index=0&id=d9424894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9424894",
  null
  
)

export default component.exports